import React from 'react';
import { Bar } from 'react-chartjs-2';

class RelEstoqueChart extends React.Component {

    constructor() {

        super();

        this.state = {
            centro: "",
            produto: "", 
        }

    }

    componentDidMount() {

        fetch("/api/centro/" + this.props.centro, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ centro: responseJson.nome });

            fetch("/api/estoque/" + this.props.produto, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response2 => response2.json())
            .then(responseJson2 => {

                this.setState({ produto: responseJson2.produto });

            });

        });

    }

    render() {
        return(
            <div>
                <br />
                <p className={ "relestoque-txt2" }>
                    <b>Centro:</b> { this.state.centro }
                </p><br />
                <p className={ "relestoque-txt2" }>
                    <b>Produto:</b> { this.state.produto }
                </p><br />
                <p className={ "relestoque-txt2" }>
                    <b>Ano:</b> { this.props.ano }
                </p><br />
                <div Style={ "width: 900px;" }>
                    <Bar data={{
                            labels: [
                                "Janeiro", "Fevereiro", "Março", "Abril", "Maio",
                                "Junho", "Julho", "Agosto", "Setembro", "Outubro",
                                "Novembro", "Dezembro"
                            ],
                            datasets: [
                                {
                                    label: this.props.unidade,
                                    fill: false,
                                    backgroundColor: "rgba(106, 123, 73, 1)",
                                    borderColor: "rgba(0, 0, 0, 1)",
                                    borderWidth: 2,
                                    data: this.props.baixas
                                }
                            ]
                        }}
                        options={{
                            title: {
                                display: true,
                                text: "Baixas no Estoque",
                                fontSize: 20
                            },
                            legend: {
                                display: true,
                                position: "right"
                            }
                        }} />
                </div>
                <br /><br />
                <form id="relestoque-form">
                    <button type="button"
                        id="relestoque-voltar-btn"
                        onClick={ this.props.voltarChart }>
                        Voltar
                    </button>
                </form>
                <br /><br />
            </div>
        );
    }

}

export default RelEstoqueChart;

